import React, { useState } from "react";
import {
  Card,
  Text,
  Group,
  List,
  ThemeIcon,
  Divider,
  Container,
  Center,
  Box,
  Image,
  Anchor,
  Checkbox,
} from "@mantine/core";
import { IconCheck, IconChecks } from "@tabler/icons-react";
import Logo from "../../assets/img/embedLogo.svg";
import { IconMail, IconWorld } from "@tabler/icons-react";
import summarySvg from "../../assets/img/ai.svg";

interface embedProps {
  title?: string;
  showBorderFunction?: any;
  checked?:boolean
  data:any
  info?:any
}

const Layout: React.FC<embedProps> = ({ title, showBorderFunction ,checked,data,info}) => {
  
  // const [checked, setChecked] = useState(false);

  // Handle checkbox change and send the updated state to the parent
  const handleChange = (event: any) => {

    showBorderFunction(event.currentTarget.checked);
  };
  
  return (
    <Box
      sx={{
        overflowY: "auto",
        // maxHeight: "83vh",
        display: "flex",
        flexDirection: "column",
        maxWidth: "800px",
        gap: "24px",
        backgroundColor: "#FAFDFF",
        // alignContent: "space-between",
        minHeight: "100%",
        justifyContent: "space-between",
        scrollBehavior: "smooth",
        // "&::-webkit-scrollbar": {
        //   width: "1px",
        // },
        // "&::-webkit-scrollbar-thumb": {
        //   backgroundColor: "#888",
        //   borderRadius: "10px",
        // },
        // "&::-webkit-scrollbar-thumb:hover": {
        //   backgroundColor: "#555",
        // },
        // "&::-webkit-scrollbar-track": {
        //   background: "#f1f1f1",
        // },
      }}
    >
      {" "}
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          // width:"500px",
          maxWidth: "500px",
          gap: "24px",
          backgroundColor: "#FAFDFF",
        }}
      >
        <Box
          sx={{
            display: "flex",
            backgroundColor: "#F1F9FF",
            height: "140px",
            //   padding: "24px 0px 24px 0px",
            justifyContent: "center",
            alignItems: "center",
            borderBottom: "1px solid #BEDEF8",
          }}
        >
          <img src={Logo} style={{ height: "177", width: "40" }} />
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "16px",
            padding: "0px 16px 0px 16px",
            overflowY: "auto",
            maxHeight: checked ? "73vh" : "63vh",
            scrollBehavior: "smooth",
            "&::-webkit-scrollbar": {
              width: "1px",
            },
            "&::-webkit-scrollbar-thumb": {
              backgroundColor: "#888",
              borderRadius: "10px",
            },
            "&::-webkit-scrollbar-thumb:hover": {
              backgroundColor: "#555",
            },
            "&::-webkit-scrollbar-track": {
              background: "#f1f1f1",
            },
          }}
        >
          <Box pl={'8px'}>
            <Text
              sx={{ fontWeight: 600, fontSize: "16px", lineHeight: "24px" }}
            >
              {title}{" "}
            </Text>
          </Box>
          {info && (
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                backgroundColor: "white",
                borderRadius: "6px",
                padding: "16px",
                boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
              }}
            >
              <Box pb={10}>
                <img  src={summarySvg} />
              </Box>
              <Box>
                <Text
                  sx={{
                    fontSize: "14px",
                    fontWeight: 400,
                    lineHeight: "21px",
                    color: "#393B3F",
                  }}
                >
                  {info}
                </Text>
              </Box>
            </Box>
          )}
          <Box
            sx={(theme) => ({
              padding: theme.spacing.md,
              borderRadius: theme.radius.md,
              backgroundColor: "white",
              boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
            })}
          >
            {data.map((item: any, index: any) => (
              <Box
                key={index}
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  gap: "12px",
                }}
              >
                <IconChecks color="#17629E" size={34} />
                {item?.description ? (
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "5px",
                    }}
                  >
                    {item?.title && <Text fw={600}>{item?.title}</Text>}
                    <Text>{item?.description}</Text>
                  </Box>
                ) : (
                  <Text>{item}</Text>
                )}
              </Box>
            ))}
          </Box>{" "}
          <Box pl={"16px"} pr={"16px"} mb={"15px"}>
            <Checkbox
              size={"xs"}
              checked={checked}
              label="Simulate launch without the EHR UI (launch without an iFrame)"
              onChange={handleChange}
            />
          </Box>
        </Box>

        {/* </Box> */}
      </Box>
      {/* b */}
    </Box>
  );
};

export default Layout;
